import React, { useEffect, useMemo } from 'react';
import {
  MapContainer, TileLayer, useMap, useMapEvents, WMSTileLayer,
} from 'react-leaflet';
import { CRS, Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './map-style.scss';
import { getJSONFromString } from '../../../utils/utils';
import { ZoomControls } from './ZoomControls';
import StableWMSLayer from './StableWMSLayer';
import AutoResize from './AutoResize';

export function EventListener({ onMove, onMoveEnd, setMap }) {
  const map = useMap();
  useMapEvents(Object.assign(
    {},
    !!onMove && typeof onMove === 'function' && {
      move: onMove,
    },
    !!onMoveEnd && typeof onMoveEnd === 'function' && {
      moveend: onMoveEnd,
    },
  ));
  useEffect(() => {
    setMap(map);
  }, []);
}

export default function LeafletMap(props) {
  const { children } = props;
  const MAP_CENTER = getJSONFromString(process.env.REACT_APP_MAP_CENTER) || [];
  const center = useMemo(() => MAP_CENTER, MAP_CENTER);
  return (
    <MapContainer
      center={center}
      zoom={13}
      scrollWheelZoom
      doubleClickZoom={false}
      zoomControl={false}
      crs={CRS.EPSG3857}
      minZoom={7}
      maxZoom={16}
    >
      <StableWMSLayer />
      <AutoResize />
      <EventListener {...props} />
      {children}
      <ZoomControls />
    </MapContainer>
  );
}
